import { gql } from '@apollo/client';

export const ORDER_MOOD = gql`
    mutation GetVotingTicketMutation($entityId: String!, $slug: String!) {
        getVotingTicket(entityType: order, entityId: $entityId, slug: $slug) {
            ticket
            entityId
            entityType
            pollMode
            payload {
                ... on MoodOptions {
                    options {
                        mood
                    }
                }
            }
        }
    }
`;

export const ORDER_MOOD_REASON = gql`
    mutation GetVotingTicketMutation($entityId: String!, $slug: String!) {
        getVotingTicket(entityType: order, entityId: $entityId, slug: $slug) {
            ticket
            entityId
            entityType
            pollMode
            payload {
                ... on SingleChoiceOptions {
                    options {
                        slug
                        label
                    }
                }
            }
        }
    }
`;

export const CAST_MOOD = gql`
    mutation CastVoteMutation($voteSlug: String!, $ticket: String!, $comment: String) {
        castVote(voteSlug: $voteSlug, ticket: $ticket, comment: $comment) {
            voteSlug
            comment
            userId
            entityId
            entityType
        }
    }
`;
